import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { pageTitle } from "@/components/document-title";
import { DamagesPage } from "@/features/damages/pages/damages-page";
import { damageFilterSchema } from "@/features/damages/schemas/damage-filter.schema";

export const Route = createFileRoute("/_authenticated/admin/damages/")({
	head: () => pageTitle("Damages"),
	component: DamagesPage,
	validateSearch: zodValidator(damageFilterSchema),
});
